<div class="bg-white rounded-xl shadow-2xl border border-gray-200 w-full max-w-2xl p-6">
  <div class="flex justify-between items-center mb-6">
    <h3 class="text-xl font-bold text-gray-800">
      <i class="fas fa-plus-circle mr-2 text-green-600"></i>Dodaj tarčo
    </h3>
    <button (click)="onCancel()" class="text-gray-400 hover:text-gray-600" [disabled]="isSaving">
      <i class="fas fa-times text-xl"></i>
    </button>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">Vrsta tarče</label>
      <select [(ngModel)]="target_type" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
        <option *ngFor="let opt of targetTypeOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">Notranji center (nc*)</label>
      <input type="number" min="0" step="1" [(ngModel)]="inner_center" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>

    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S10</label>
      <input type="number" step="0.1" [(ngModel)]="S10" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S20</label>
      <input type="number" step="0.1" [(ngModel)]="S20" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S30</label>
      <input type="number" step="0.1" [(ngModel)]="S30" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S40</label>
      <input type="number" step="0.1" [(ngModel)]="S40" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S50</label>
      <input type="number" step="0.1" [(ngModel)]="S50" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-1">S60</label>
      <input type="number" step="0.1" [(ngModel)]="S60" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
    </div>
  </div>

  <div class="flex justify-end gap-3 mt-6">
    <button (click)="onCancel()" class="px-5 py-2 rounded-lg bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300" [disabled]="isSaving">
      Prekliči
    </button>
    <button (click)="onSave()" class="px-5 py-2 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 shadow-md" [disabled]="isSaving">
      <i class="fas fa-save mr-2"></i>{{ isSaving ? 'Shranjujem...' : 'Shrani' }}
    </button>
  </div>
</div>
